module.exports = __webpack_public_path__ + "img/pay01.19e6021c.png";